export let SRCenter = {
    Center: 0, // rotate or scale around center of polygon
    Opposite: 1, // rotate or scale around opposite side of polygon
  };